import {
  EPayload,
  EActionType,
  IActionButtonSchema,
} from '../repositories/cian-chat-bot/entities/action_buttons/ActionButtonSchema';
import { IProcessActionButtonsResponseSchema } from '../repositories/cian-chat-bot/entities/action_buttons/ProcessActionButtonsResponseSchema';
import {
  fetchProcessActionButtons,
  TProcessActionButtonsResponse,
} from '../repositories/cian-chat-bot/v1/process-action-buttons';
import { TContext } from '../types/context';
const DEGRADATION_TELEMETRY_KEY = 'degradation.chatbotActionButtons';

export { EPayload as EChatbotPayload, EActionType as EChatbotActionType };
export type {
  IProcessActionButtonsResponseSchema as IChatbotActionButtons,
  IActionButtonSchema as IChatbotActionButton,
};

export async function fetchChatbotActionButtons(
  { httpApi, logger, telemetry }: TContext,
  payload: EPayload,
): Promise<IProcessActionButtonsResponseSchema | null> {
  try {
    const { statusCode, response }: TProcessActionButtonsResponse = await fetchProcessActionButtons({
      httpApi,
      parameters: {
        payload,
      },
    });

    if (statusCode !== 200) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);
      logger.warning('Невалидный ответ от сервера', {
        domain: 'src/shared/services/fetchChatbotActionButtons.ts',
        statusCode,
        messsage: response.message,
        errors: JSON.stringify(response.errors),
      });

      return null;
    }

    return response;
  } catch (error) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.error(error, {
      message: 'Не удалось получить кнопки чатбота',
      domain: 'src/shared/services/fetchChatbotActionButtons.ts',
    });

    return null;
  }
}
